import React from "react";
import { Routes, Route } from "react-router-dom";
import { Login, ContactUs, ResetPassword, VerifyEmail, Payments, RecoverUsername, Register } from 'pages'
import { Main, ThankYou } from 'components'
import { app } from "./routes";
import { PrivateRoutesApp, PrivateRoutesAuth } from ".";

const CreateRouter = () => {
    return (
        <Routes>
            <Route exact path={app.login} element={
                <PrivateRoutesAuth>
                    <Login />
                </PrivateRoutesAuth>
            } />
            <Route exact path={"/reset/*"} element={
                <PrivateRoutesAuth>
                    <ResetPassword />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.recoverUsername} element={
                <PrivateRoutesAuth>
                    <RecoverUsername />
                </PrivateRoutesAuth>
            } />
            <Route exact path={app.thankYou} element={
                <ThankYou />
            } />
            <Route exact path={"/verify/:token"} element={
                <PrivateRoutesAuth>
                    <VerifyEmail />
                </PrivateRoutesAuth>
            } />
            <Route exact path={"/register/*"} element={
                <PrivateRoutesAuth>
                    <Register />
                </PrivateRoutesAuth>
            }>
            </Route>
            <Route exact path={app.payments} element={
                <Payments />
            }>
            </Route>
            <Route exact path={app.contactUs} element={
                <ContactUs />
            }>
            </Route>
            <Route exact path="/*" element={
                <PrivateRoutesApp>
                    <Main />
                </PrivateRoutesApp>
            } />
        </Routes >
    );
}

export default CreateRouter
